import {
  FETCH_INVITATIONS_REQUEST,
  FETCH_INVITATIONS_SUCCESS,
  FETCH_INVITATIONS_FAILURE
} from '../actions/invitations';

const invitations = (state = [], action) => {
  switch (action.type) {
    case FETCH_INVITATIONS_REQUEST:
      return {
        ...state
      };
    case FETCH_INVITATIONS_SUCCESS:
      return {
        ...state,
        invitations: action.invitations,
        error: false
      };
    case FETCH_INVITATIONS_FAILURE:
      return {
        ...state,
        error: true
      };
    default:
      return state;
  }
};

export default invitations;



// WEBPACK FOOTER //
// ./src/reducers/invitations.js